import { EmailPreviewRequest } from "./email-preview-request";

export class EmailSendRequest extends EmailPreviewRequest {
  to: string;
  documentId?: string;
  includeAttachedFiles?: boolean;

  constructor(data: Partial<EmailSendRequest> = {}) {
    super(data);
    this.to = data.to ?? '';
  }
}
